import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import queryString from "query-string";

import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as helpReducer from "containers/Help/reducer";

import Redirect from "components/Login/Redirect";

class RedirectContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const {} = this.props;

    return <Redirect {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleRedirect: (uri) => helpReducer.openUri(uri, true)
});

const mapStateToProps = (state, ownProps) => {
  return {
    isDellDomain: loginReducer.getIsDellDomain(),
    domainRedirect: loginReducer.getDomainRedirect(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RedirectContainer);
